"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "m15.407 11.922-5.653 3.792V8.203l5.653 3.719Zm3.32-9.943a5.28 5.28 0 0 1 5.269 5.056l.004.217v9.496a5.28 5.28 0 0 1-5.057 5.269l-.217.004H5.273a5.28 5.28 0 0 1-5.269-5.056L0 16.748V7.252a5.279 5.279 0 0 1 5.056-5.269l.217-.004h13.453Zm0 1.049H5.272c-2.22 0-4.107 1.819-4.219 4.017l-.005.207v9.496c0 2.22 1.819 4.107 4.017 4.22l.207.004h13.453c2.22 0 4.107-1.82 4.219-4.017l.005-.207V7.252c0-2.22-1.819-4.107-4.017-4.22l-.207-.004ZM9.143 6.8l.07-.011c.088-.016.193-.034.282.01l.062.045 7.103 4.732c.101.098.216.21.216.424a.5.5 0 0 1-.154.364l-.043.044-7.142 4.764a.344.344 0 0 1-.25.1l-.058.001c-.055 0-.194 0-.256-.094-.138-.041-.238-.17-.263-.342l-.007-.09V7.253c0-.226.119-.398.291-.437l.15-.015Z",
    clipRule: "evenodd"
  })]
});